var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-pdfIcon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pdfIcon",
    clipPath: "url(#clip-pdfIcon)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_awesome-file-pdf",
    "data-name": "Icon awesome-file-pdf"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M0,0,11.335-.028,16.992,5,17,20H0Z",
    transform: "translate(0 0.028)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-file-pdf-2",
    "data-name": "Icon awesome-file-pdf",
    d: "M8.053,10a3.341,3.341,0,0,1-.089-1.832C8.336,8.172,8.3,9.613,8.053,10Zm-.075,1.844A17.076,17.076,0,0,1,6.72,14.3,17.8,17.8,0,0,1,9.5,13.441,5.29,5.29,0,0,1,7.978,11.848ZM3.812,16.723c0,.031.584-.211,1.545-1.57A5.676,5.676,0,0,0,3.812,16.723ZM10.979,6.25H17V19.063A1,1,0,0,1,15.938,20H1.063A1,1,0,0,1,0,19.063V.938A1,1,0,0,1,1.063,0H9.917V5.313A1.009,1.009,0,0,0,10.979,6.25Zm-.354,6.711a4.054,4.054,0,0,1-1.89-2.1,4.991,4.991,0,0,0,.274-2.508,1.151,1.151,0,0,0-2.116-.266,5.774,5.774,0,0,0,.359,3.008,34.957,34.957,0,0,1-1.806,3.352s0,0-.009,0c-1.2.543-3.258,1.738-2.413,2.656a1.463,1.463,0,0,0,.952.391c.792,0,1.58-.7,2.7-2.414a27.844,27.844,0,0,1,3.5-.906,7.381,7.381,0,0,0,2.833.762,1,1,0,0,0,.872-1.7c-.615-.531-2.4-.379-3.258-.281ZM16.69,4.1,12.352.273A1.138,1.138,0,0,0,11.6,0h-.266V5H17V4.762A.882.882,0,0,0,16.69,4.1Zm-3.28,9.973c.182-.105-.111-.465-1.895-.352C13.157,14.34,13.41,14.074,13.41,14.074Z",
    transform: "translate(0 0.028)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M-3819.5-985.23H-3834a1,1,0,0,1-1-1v-1h12.829a3.764,3.764,0,0,0,1.431-1.85c1.191-2.462.74-9.892.74-9.892h2v12.742a1,1,0,0,1-1,1Z",
    transform: "translate(3835 1005.258)",
    fill: "#d40000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M-3835-992.472v-1a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5A.5.5,0,0,1-3835-992.472Zm0-3v-3a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v3a.5.5,0,0,1-.5.5A.5.5,0,0,1-3835-995.472Z",
    transform: "translate(3836 1000)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdfIcon.bcf5df77207401e4ed53c754bf181933.svg";
export { ForwardRef as ReactComponent };